export const table_titles = [
	{ name: "Cliente", size: 10, order: "", only_admin: true },
	{ name: "Código", size: 10, order: "" },
	{ name: "Tipo", size: 10, order: "" },
	{ name: "Fecha", size: 10, order: "" },
	{ name: "Peso Balanza", size: 10, order: "", only_admin: true },
	{ name: "Peso Salida / Utilizado", size: 10, order: "" },
	{ name: "Usuario", size: 10, order: "" },
	{ name: "Vacío", size: 5, order: "" },
	{ name: "No Usado", size: 5, order: "" },
	{ name: "", size: 5, order: "" },
];

export const customStyles = {
	menuPortal: (base) => ({
		...base,
		zIndex: 9999999,
	}),
	menu: (provided) => ({ ...provided, zIndex: 9999999 }),
};

export const filters = {
	filter_customer_id: "",
	filter_date: "",
	filter_date_to: "",
};
